module.exports = __webpack_public_path__ + "static/img/52b6bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/lhsx/txgg_top.png
// module id = 650
// module chunks = 2